module.exports = __webpack_public_path__ + "img/dbcpfw_11.7fd61699.jpg";